export default {
  AddFix: '修理を報告する',
  searchorder: '修理番号を検索',
  placeholderOrderFix: '修理番号',
  searchworkerid: '作業者IDを検索',
  workerid: '従業員ID',
  searchUser: 'ユーザーを検索',
  user: 'ユーザー名',
  email: 'メールアドレス',
  password: 'パスワード',
  phone: '電話番号',
  jobtitle: '職位',
  searchEmail: 'メールで検索',
  emailname: 'メール名',
  searchdept: '部署名で検索',
  deptname: '部署名',
  searchrole: 'ユーザー役割で検索',
  role: 'ユーザー役割',
  uppersearchrole: '全大文字 (USER)',
  startDate: '開始日を選択',
  endDate: '終了日を選択',
  search: '検索',
  WaitImprove: '承認待ち',
  fixstatus: '修理を報告する',
  fixing: '修理進行中',
  claim: '修理依頼/送信',
  confirmjob: '検査待ち',
  cancelSucc: 'キャンセル/成功',
  nofix: '修理依頼なし',
  allfixjob: 'すべての修理依頼',
  showfixjob: '修理作業を表示',
  returnfixjob: '修理作業を戻す',
  deviceedit: 'デバイス管理',
  fixedit: '修理管理',
  allimprove: 'すべて承認',
  fixcancel: '修理キャンセル',
  fixcancelDetails: 'キャンセルの備考',
  fixcancelDetailsinput: 'キャンセルの備考を入力',
  cancelconfirm: 'キャンセルを確認',
  cancel: 'キャンセル',
  rate: '評価',
  ratescore: 'スコア（1 = 最低、5 = 最高）',
  comment: 'コメント',
  commentInput: 'コメントを入力',
  sendcomment: 'フィードバックを送信',
  thankForhelp: 'ご協力ありがとうございます',
  thankForhelpText: '評価にご協力いただきありがとうございます！',
  close: '閉じる',
  loading: 'データを読み込み中...',
  getfixjob: '受け取った日付',
  fixDate: '修理日',
  cate: 'カテゴリ',
  subcate: 'サブカテゴリ',
  device: 'デバイス',
  fixDetails: '修理の詳細',
  problem: '原因/問題',
  operator: '外部技術者',
  operatorinput: '外部技術者を入力',
  status: '状態',
  management: '管理',
  worker: '修理作業者',
  fixinfo: '修理情報',
  typefix: '修理タイプ',
  subcatefix: '修理のサブカテゴリ',
  deviceinfo: 'デバイス情報',
  devicecate: 'メインデバイスカテゴリ',
  devicesubcate: 'デバイスサブカテゴリ',
  fixinfodetails: '修理の詳細',
  fixdetailstitle: '修理の詳細',
  problemdetails: '問題の詳細を入力',
  problemdetailsinput: '問題の詳細を入力',
  text150: '150文字以内でメッセージを入力してください',
  text100: '100文字以内でメッセージを入力してください',
  text50: '50文字以内でメッセージを入力してください',
  text30: '30文字以内でメッセージを入力してください',
  image: '画像',
  imageinfo: '画像情報',
  addimage: '画像を追加',
  addimagefix: '修理後の画像を追加',
  submit: '保存',
  notification: '通知',
  confirm: '確認',
  noticdetailsfix: '正しい修理内容を入力してください',
  text: 'テキスト',
  selectimage: '画像ファイルを選択',
  notfoundsubcate: 'サブカテゴリが見つかりません',
  warning: '警告',
  error: 'エラー',
  getsubcatefailed: 'サブカテゴリのデータ取得に失敗しました',
  notfoundsubcateIndevice: 'このサブカテゴリにデバイスデータが見つかりません',
  getdevicefailed: 'デバイスデータの取得に失敗しました',
  notfoundsubcatedevice: 'このサブカテゴリにデバイスデータが見つかりません',
  getsubcatedevicefailed: 'デバイスのサブカテゴリデータの取得に失敗しました',
  expenseinfo: '費用情報',
  addexpense: '費用を追加',
  selectcateexpense: '費用カテゴリを選択',
  expense: '費用（単位）',
  remark: '備考',
  remarkinput: '備考を入力',
  sum: '合計',
  totalcost: '総費用',
  spareinfo: '予備部品情報',
  spare: '予備部品',
  addlist: 'アイテムを追加',
  list: 'リスト',
  listinput: 'アイテムを入力',
  orderbuy: '購入注文番号',
  orderbuyinput: '購入注文番号を入力',
  amount: '数量',
  amountinput: '数量を入力',
  cost: '費用',
  sourcespare: '予備部品の供給元',
  sourcespareinput: '予備部品の供給元を入力',
  fixdetails: '問題の詳細',
  fixdetailsinput: '問題の詳細を入力',
  reasondetails: '原因の詳細',
  reasondetailsinput: '原因の詳細を入力',
  solution: '解決策の詳細',
  solutioninput: '解決策/修理内容を入力',
  admindetails: '管理者の詳細',
  requesttype: 'リクエストタイプ',
  Expectedcompletion: '予想完了日',
  fixdone: '完了日',
  expenseSubcateName: '費用のサブカテゴリ',
  expenseCateName: '費用カテゴリ',
  change: '変更',
  fix: '修理',
  check: '確認',
  orderlist: '注文',
  deleteconfirm: 'このアイテムを削除してもよろしいですか？',

  userinfo: 'ユーザー情報',
  operatorinfo: '操作情報',
  infodetails: '詳細情報',
  feedbackinfo: '満足度情報',
  feedback: '満足度',
  reason: '理由',
  imagefix: '修理後の画像',
  noimage: '画像なし',
  noimagefix: '修理後の画像なし',
  talk: 'チャット',
  showpdf: 'PDFを表示',
  improve: '承認',
  showimage: '画像を表示',
  send: '送信',
  sir: '様',
  notfoundname: '名前が見つかりません',
  typeing: 'メッセージを入力中...',
  enterdevice: 'デバイスを選択してください',
  entersubdevice: 'デバイスのカテゴリを選択してください',
  confirmfixer: '作業の確認"',
  confirmdetails: 'この項目を確認してもよろしいですか？',
  confirmapprove: '承認',
  files: '書類',
  filesdone: '書類（修理後）',
  nofiles: '書類が見つかりません',

  // Navigation bar page
  requestsearch: '修理リクエストリスト',
  calendar: '予防保守 (PM)',
  calendarView: '予防保守 (PM)',
  updatesearch: '修理リクエストリスト',
  adminsearch: '修理リクエストリスト',
  usersearch: '従業員リスト',
  dashboard: 'レポート',
  settings: '設定',
  userform: '従業員リストの編集',
  devicelist: 'デバイスリストの編集',
  departmentform: '部署リストの編集',
  CategoryManagement: '問題カテゴリの編集',
  Expense: '費用リストの編集',
  deviceCate: 'デバイスカテゴリの編集',
  location: '場所リストの編集',
  jobtitleEdit: '職位の編集',

  // Calendar
  nodetails: '詳細なし',
  start: '開始',
  starttime: '開始時間',
  endtime: '終了時間',
  end: '終了',
  devicename: 'デバイス名',
  details: '詳細',
  deleteconfirmEvent: 'イベントの削除を確認',
  title: 'タイトル',
  confirminput: '必要な情報をすべて入力してください',
  adduser: 'メンバーを追加',
  edit: '編集',

  // User
  nosignature: '署名なし',
  active: 'アクティブ',
  nonactive: '非アクティブ',
  enable: '有効',
  nonuser: 'メンバーデータなし',
  uploadimage: 'プロフィール画像をアップロード',
  drawsignature: '署名を描く',
  clearsignature: '署名をクリア',
  update: '更新',
  newadd: '新規追加',
  userlist: '従業員リスト',
  employeeinfo: '従業員情報',
  fullname: '氏名',
  signature: '署名',
  nonuserdetails: '従業員データが見つかりません',
  youwant: 'したいですか？',
  yesorno: 'はい または いいえ',

  // Dashboard
  all: 'すべて',
  year: '年',
  month: '月',
  day: '日',
  fixrequest: '修理リクエスト',
  totalall: '合計数',
  totalcostall: '総費用',
  fixrequeststatus: '修理リクエストのステータス',
  expensefix: '修理費用',
  bath: 'バーツ',
  sparecost: '予備部品費用',
  alluser: 'すべてのユーザー',
  person: '人',
  devicestatuslist: 'デバイスステータスリスト',
  alldevice: 'すべてのデバイス',
  pmlist: 'PMデバイスリスト',
  nodata: 'データなし',
  repairCount: '修理回数',
  fixcostdevice: 'デバイス別修理費用',
  fixcost: '修理費用',
  sparecostdevice: 'デバイス別予備部品費用',
  employeerole: '役職別従業員数',
  pmamount: 'PMデバイスの数',
  getdevice: '受け取った日',

  adddevice: 'デバイスを追加',
  selectsearchtype: '検索タイプを選択',
  nondevice: 'リストにデバイスなし',
  sndevice: 'デバイス番号',
  model: 'モデル',
  locationname: '場所',
  searchsndevice: 'デバイス番号で検索',
  searchnamedevice: 'デバイス名で検索',
  searchmodel: 'モデルで検索',
  searchcate: 'カテゴリで検索',
  searchsubcate: 'サブカテゴリで検索',
  searchuser: 'ユーザーで検索',
  searchdepartment: '部署で検索',
  searchlocation: '場所で検索',
  searchcost: '価格で検索',
  searchstatus: 'ステータスで検索',
  catedevice: '主なデバイスカテゴリ',
  subcatedevice: 'デバイスのサブカテゴリ',
  warrantydetails: '保証情報',
  warrantydetail: '保証の詳細',
  providerName: 'サービス提供者名',
  warrantytime: '保証期間（年、月、日）',
  expdate: '有効期限',
  nodatawarranty: '保証情報なし',
  nowarranty: '保証なし',
  hardwaredetails: 'ハードウェア情報',
  detailsinput: '詳細を入力',
  nodetailshardware: 'ハードウェア詳細なし',
  devicestatus: 'デバイスステータス',
  assetType: '資産タイプ',
  otherdetails: '追加情報',
  detailsanother: '追加詳細',
  detailsanotherinput: '追加詳細を入力',
  edituserdevice: 'デバイスユーザーを編集',
  zeroyear: '0年',
  zeromonth: '0ヶ月',
  zeroday: '0日',
  use: '使用中',
  nonuse: '使用していない',
  sellscrap: 'スクラップを販売',
  rent: 'レンタル',
  buy: '購入',
  vendor: 'ベンダー名',
  warrantyday: '保証期間（日数）',
  warrantyExp: '有効期限',
  exp: '期限切れ',
  after: '残り ',
  hour: '時間',
  inday: '今日中',
  confirmdelete: 'このアイテムを削除してもよろしいですか？',
  deviceinfodetails: 'デバイス詳細',
  warrantydevice: 'デバイス保証詳細',
  fixhistory: '修理履歴',
  userdevicehistory: 'ユーザーのデバイス履歴',
  nondevicedetails: 'デバイス履歴データなし',
  outofdate: '使用終了日',
  startuse: '使用開始',
  enduse: '使用終了',
  delconfirm: '削除を確認',
  yes: 'はい',
  searchworkername: '修理担当者を検索',
  workername: '修理担当者の名前',
  fixworker: '作業員のタスク数のリスト',
  repairstatusCount: '修理ステータスの件数',
  fixstatusworker: '修理ステータス件数の一覧',
  costdevice: 'デバイスの数',
  statusfix: 'サービスの種類',
  pmcount: 'PMの回数',
  times: '回数',
  dateselect: '正しい日付を選択してください',
  notfoundlist: '検索したアイテムが見つかりませんでした。もう一度お試しください。',
  searchdevice: 'デバイスを検索',
  searchtitlename: 'タイトルで検索',
  titlename: 'タイトル',
  pmhistory: 'メンテナンス履歴(PM)',

  // Department
  deptid: '部署ID',
  adddept: '部署を追加',
  editdept: '部署を編集',
  nodeptdetails: '部署記録なし',

  // Category
  editlist: 'リストを編集',
  addcate: 'カテゴリを追加',
  catename: 'カテゴリ名',
  subcatename: 'サブカテゴリ名',
  add: '追加',
  editsubcate: 'サブカテゴリを編集',
  addsubcate: 'サブカテゴリを追加',
  reset: 'リセット',
  searchcateAndsubname: 'メイン/サブカテゴリを検索',

  // Location
  searchlocationname: '場所名',
  addlocation: '場所を追加',
  editlocation: '場所を編集',
  nolocationlist: '場所記録なし',

  // Job title
  jobtitlename: '職位名',
  addjobtitle: '職位を追加',
  selectdept: '部署を選択',
  editjobtitle: '職位を編集',
  nojobtitlelist: '職位記録なし',

  // Others
  notfoundsearch: '検索結果が見つかりません',
  pmdevice: 'デバイス',
  time: '期間',
  today: '今日',
  datailsanother: 'その他の詳細',
  useddelete: '使用中で削除できません',
  confirmapproveall: 'すべて承認',
  confirmapprovealldetails: 'すべての修理依頼を承認してもよろしいですか？',
  Profile: 'プロフィール',
  logout: 'ログアウト',
  other: 'その他',

  // error page
  pagenotfound: 'ページが見つかりません',
  pagenotfounddetails: 'おっと! リクエストされたURLはこのサーバーに見つかりませんでした',
  backhome: 'ホームに戻る',

  delete: '削除',
  Collapse: '折りたたむ',
  Expand: '展開',
  getjob: '受ける',
  phoneinput: '電話番号 / 内線番号を入力してください',
  resetpassword: 'パスワードリセット',
  passwordold: '現在のパスワード',
  passwordnew: '新しいパスワード',
  passwordconfirm: '新しいパスワードの確認',
  passwordUpdateSuccess: '新しいデータの更新に成功しました！',
  success: '成功',
  headcheck: '承認待ち',

  quantity: '数量',
  unit: '単位',
  sn: 'シリアル番号',
  sninput: 'シリアル番号を入力',
  searchsn: 'シリアル番号で検索',
}
